import React from 'react';
import '../Portfolioes/Portfolioes.css';

const ProjectDetails = ({project}) => {
    const {img, name,title, id, url, client, Date, autor} = project;
    return (
                   
                       
                    <div className="portfolio-details serviceData">
                       <img className="animate__animated animate__fadeInUp animate__delay-2s" src={img} alt="" />
                        <h6 className="animate__animated animate__fadeInRight animate__delay-2s">Developer: {autor}</h6>
                        <div className="d-flex  animate__animated animate__fadeInLeft animate__delay-3s">
                        <p>Date: {Date}</p>
                        <a href={url}><span className="ml-3">Live Demo</span></a>
                        </div>
                   </div>
    );
};

export default ProjectDetails;